<app-subscribe-page
    backgroundColor="#dad3ea"
    context="resources"
    height="auto">
</app-subscribe-page>
